<app-header></app-header>
<div class="middle-content-wrap">
    <div class="globalheading dflex dflex_bet">
        <h2>User Metrics</h2>
        <div class="controls-row">
            <div class="filter-group mr-2">
                <label class="filter-label">Gender</label>
                <select class="select-filter" (change)="onGenderChange($event)" [value]="gender">
                    <option *ngFor="let opt of genderOptions" [value]="opt.value">{{ opt.label }}</option>
                </select>
            </div>

            <div class="filter-group">
                <label class="filter-label">Subscription Type</label>
                <select class="select-filter" (change)="onSubscriptionChange($event)" [value]="subscription_type">
                    <option *ngFor="let opt of subscriptionOptions" [value]="opt.value">{{ opt.label }}</option>
                </select>
            </div>

            <div class="filter-group ml-2">
                <label class="filter-label">Subscription Package</label>
                <select class="select-filter" (change)="onSubscriptionPackageChange($event)"
                    [value]="subscriptionPackage">
                    <option *ngFor="let opt of subscriptionPackageOptions" [value]="opt.value">{{ opt.label }}</option>
                </select>
            </div>

            <div class="filter-group ml-2">
                <label class="filter-label" style="visibility: hidden;">Export</label>
                <button class="btn btn-export" (click)="onExport()">Export</button>
            </div>
        </div>
    </div>

    <div class="listingformat">
        <div class="tabledatawrap table-responsive">
            <!-- Ensure loading is handled or default to empty list -->
            <table>
                <thead>
                    <tr>
                        <th>Image</th>
                        <th>User ID</th>
                        <th>Name</th>
                        <th>Occupation</th>
                        <th>Gender</th>
                        <th>Nationality</th>
                        <th (click)="onSort('age')">Age <i class="fa"
                                [ngClass]="{'fa-sort-up': sortBy === 'age' && sortDir === 'ASC', 'fa-sort-down': sortBy === 'age' && sortDir === 'DESC', 'fa-sort': sortBy !== 'age'}"></i>
                        </th>
                        <th (click)="onSort('active_score')">Active Score <i class="fa"
                                [ngClass]="{'fa-sort-up': sortBy === 'active_score' && sortDir === 'ASC', 'fa-sort-down': sortBy === 'active_score' && sortDir === 'DESC', 'fa-sort': sortBy !== 'active_score'}"></i>
                        </th>
                        <th (click)="onSort('attractiveness_score')">Attractiveness Score <i class="fa"
                                [ngClass]="{'fa-sort-up': sortBy === 'attractiveness_score' && sortDir === 'ASC', 'fa-sort-down': sortBy === 'attractiveness_score' && sortDir === 'DESC', 'fa-sort': sortBy !== 'attractiveness_score'}"></i>
                        </th>
                        <th (click)="onSort('total_yes')">Total Yes <i class="fa"
                                [ngClass]="{'fa-sort-up': sortBy === 'total_yes' && sortDir === 'ASC', 'fa-sort-down': sortBy === 'total_yes' && sortDir === 'DESC', 'fa-sort': sortBy !== 'total_yes'}"></i>
                        </th>
                        <th (click)="onSort('total_pass')">Total Pass <i class="fa"
                                [ngClass]="{'fa-sort-up': sortBy === 'total_pass' && sortDir === 'ASC', 'fa-sort-down': sortBy === 'total_pass' && sortDir === 'DESC', 'fa-sort': sortBy !== 'total_pass'}"></i>
                        </th>
                        <th>Subscription</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of metricsList | paginate: { itemsPerPage: limit, currentPage: p, totalItems: total }"
                        (click)="navigateToCustomerDetail(item.user_id)">
                        <td>
                            <img [src]="item.profile_image" class="profile-img" alt="Profile">
                        </td>
                        <td>{{ item.user_id }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.occupation }}</td>
                        <td>
                            <span class="badge-gender" [ngClass]="item.gender">{{ item.gender }}</span>
                        </td>
                        <td>{{ item.nationality }}</td>
                        <td>{{ item.age }}</td>
                        <td>{{ item.active_score }}</td>
                        <td>{{ item.attractiveness_score }}</td>
                        <td>{{ item.total_yes }}</td>
                        <td>{{ item.total_pass }}</td>
                        <td>{{ item.subscription_type }}</td>
                    </tr>
                    <tr *ngIf="metricsList.length === 0 && !loading">
                        <td colspan="12" style="text-align: center;">No metrics found</td>
                    </tr>
                    <tr *ngIf="loading">
                        <td colspan="12" style="text-align: center;">Loading...</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="col-md-12 custompagination">
                <pagination-controls (pageChange)="onPageChange($event)" previousLabel="Prev"
                    nextLabel="Next"></pagination-controls>
            </div>
        </div>
    </div>
</div>